import MainScene from './MainScene';

export default MainScene;
